// TODO GAL6: repalce with SWAN responsive system
export const SMALL_SCREEN_WIDTH = 768

export const DEFAULT_CONTENT_BACKGROUND_COLOR = 'rgb(#ffffff)'

export enum TILE_PREVIEW_SIZE {
  DEFAULT = 'Default',
  LARGE = 'Large',
}

export enum LOADING_TYPE {
  EAGER = 'eager',
  LAZY = 'lazy',
}

export const DEFAULT_EAGER_IMAGES = 8

export const DEFAULT_TENANT = 'vistaprint'

export const DEFAULT_TENANT_ID_PREFIX = 'VP'

export const WES_TENANT = `vp-template-favorites-${process.env.NODE_ENV}`

export const MINIMUM_TILE_DEFAULT_WIDTH = 206

export const MINIMUM_TILE_LARGE_WIDTH = 258

export const SINGLE_SPACE_ENCODED = '&nbsp;'

export enum PRICING_PRESENTATION_TYPES {
  QTY_FROM_PRICE = 'qtyFromPrice',
  AS_LOW_AS_PRICE_PER_PIECE = 'asLowAsPricePerPiece',
  PRICE_PER_UNIT = 'pricePerUnit',
  RAW_PRICE = 'rawPrice',
  QTY_DIFFERENTIAL_PRICE = 'plusOrMinus',
  DIFFERENTIAL_PRICE_PER_UNIT = 'plusOrMinusPerUnit',
  QTY_STARTING_AT_PRICE = 'qtyStartingAtPrice',
}

export const CHOICE_GROUP_BATCH_SIZE = 2

// 14 minutes - 1 minute less than cache time
export const PRICING_STALE_TIME = 840000
export const PRICING_CACHE_TIME = 900000

export enum PAGE_ACTION_TYPES {
  GALLERY_CONFIG_LOAD_FAILED = 'galleryConfigurationLoadFailed',
  GALLERY_CONFIG_METADATA_LOAD_FAILED = 'galleryConfigurationMetadataLoadFailed',
  CONTENT_LOAD_FAILED = 'contentLoadFailed',
  PREVIEW_IMAGE_FAILURE = 'previewImageFailure',
  FAVORITES_UPDATE_FAILED = 'favoritesUpdateFailed',
  LOADED_FAVORITES = 'loadedFavorites',
  FAVORITE_BUTTON_CLICKED = 'favoriteButtonClicked',
  PRODUCT_CONFIG_LOAD_FAILED = 'productConfigurationLoadFailed',
  QUICKVIEW_OPENED = 'quickViewOpened',
  VORTEX_RENDER_FAILURE = 'vortexFailure',
  FAVORITE_DUPLICATE_DETECTED = 'favoriteDuplicateDetected',
  ADD_TO_CART_SUCCESS = 'addToCart',
  ADD_TO_CART_FAILURE = 'addToCartFailure',
  IMAGE_UPLOAD_SUCCESS = 'imageUploadSuccess',
  IMAGE_UPLOAD_FAILURE = 'imageUploadFailure',
  IMAGE_PROCESSING_SUCCESS = 'imageProcessingSuccess',
  IMAGE_PROCESSING_FAILURE = 'imageProcessingFailure',
  IMAGE_LOADING_SUCCESS = 'imageLoadingSuccess',
  IMAGE_LOADING_FAILURE = 'imageLoadingFailure',
  SEGMENT_EVENT_FAILURE = 'segmentEventFailure',
}

export enum LOCAL_STORAGE_KEYS {
  PERSISTED_BRAND_APPLIED = 'PERSISTED_BRAND_APPLIED',
  PERSISTED_DPSESSION = 'PERSISTED_DPSession',
  V2_PERSISTED_SESSION = 'V2_PERSISTED_SESSION',
  V2_ACTIVE_SESSION = 'V2_ACTIVE_SESSION',
}

export const SELECTED_PRODUCT_QSP = 'selectedProduct'

export enum IMAGE_UPLOAD_STATES {
  LOADING = 'LOADING',
  READY = 'READY',
  ERROR = 'ERROR',
}

export const MAX_PHOTO_UPLOADS = 10

export const QV_PREVIEW_ID = 'quickview-preview'

export const MAX_COLOR_WEIGHT_DIFFERENCE_PERCENT = 5

export const PRIMARY_COLOR_SWATCH_INDEX = 0
export const SECONDARY_COLOR_SWATCH_INDEX = 1
export const SIMILARITY_COLOR_SWATCH_RATIO = 0.5
export const COLOR_SWATCH_DIFFERENCE_THRESHOLD = 25

export const NA_GREETING_TAXONOMY_ID = '08da7bc0-34c9-4a38-83d4-0d5f98410ea7'
export const NA_HC_GALLERY_ID = 632

export const ANZS_GREETING_TAXONOMY_ID = '08da8b8c-7403-4d06-8c3c-65bfb5a76823'
export const ANZS_HC_GALLERY_ID = 1389

export const PAGE1_TILE_POSITION_RANGE = [21, 44, 67, 90]
export const TILE_POSITION_RANGE = [23, 47, 71, 95]

export const IS_BROWSER = typeof window !== 'undefined'

export enum TEMPLATE_INTERACTION_TYPE {
  TEMPLATE_ORDERED = 'TemplateOrdered',
}

export enum TEMPLATE_INTERACTION_SUBTYPE {
  TEMPLATE_TOKEN = 'TemplateToken',
}

// 3 years
export const PREVIOUSLY_ORDERED_DAYS_OF_HISTORY = '1095'
